var carousel = {

    selectors: {
        elements: '[data-carousel]'
    },

    init: function() {
        var self = this,
            $elements = $( self.selectors.elements );

        $elements.slick( {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            infinite: false,
            mobileFirst: true,
            arrows: false,
            rows: 0,
            responsive: [ {
                    breakpoint: 520,
                    settings: {
                        slidesToShow: 1.7,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2.5,
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3.5,
                    }
                }, {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5,
                    }
                }
            ]
        } );

        $elements.on( 'beforeChange', function() {
            window.theme.globals.disableClick = true;
        } );

        $elements.on( 'afterChange', function() {
            window.theme.globals.disableClick = false;
        } );
    },
}

export {
    carousel
};
